import { UntypedFormBuilder, Validators } from "@angular/forms";
import { BaseFormBuilder } from "src/app/core/formBuilders/BaseFormBuilder";
import { PortalMessageRecipient } from "./PortalMessageRecipient";
import { ApplicationPortalType } from "src/app/shared/model/ApplicationPortalType";
import { PortalMessageAttachment } from "./PortalMessageAttachment";

export interface PortalMessage {
    id: number;
    threadId:string;
    applicationPortalTypeId: number;
    senderRoleId: number;
    senderInfo: string;
    senderEmailFrom: string;
    senderPortalUserId: string;
    sendingChannelTypeId: number;
    linkedToMessageId: number;
    title: string;
    contentText: string;
    createdBy?: string;
    claimIdentifier: string;
    timestamp?: string;
    isRemoved: boolean;
    recipients: PortalMessageRecipient[];
    attachments: PortalMessageAttachment[];
    templateId?: number;
    isPriority: boolean;
}


export class PortalMessageFormBuilder extends BaseFormBuilder {

    static getForm(fb: UntypedFormBuilder, message: PortalMessage) {
  
      return fb.group(
        {
          id: [message.id],
          threadId: [message.threadId],
          applicationPortalTypeId : [message.applicationPortalTypeId],
          claimIdentifier: [message.claimIdentifier,[Validators.required]],
          senderRoleId: [message.senderRoleId],
          senderInfo: [message.senderInfo],
          senderEmailFrom: [message.senderEmailFrom],
          senderPortalUserId: [message.senderPortalUserId],
          linkedToMessageId: [message.linkedToMessageId],
          title: [message.title],
          contentText: [message.contentText,[Validators.required]],
          isRemoved: [message.isRemoved],
          sendingChannelTypeId: [message.sendingChannelTypeId],
          recipients:[message.recipients],
          attachments:[message.attachments],
          templateId: [message.templateId],
          isPriority: [message.isPriority]
        });
    }
    
    static initPortalMessage(sendingChannelTypeId:number, threadId:string): PortalMessage {

        return {
            
            id: 0,
            claimIdentifier: '',
            threadId:threadId,
            linkedToMessageId: 0,
            title: '',
            contentText: '',
            applicationPortalTypeId : ApplicationPortalType.ClaimCenter,
            senderRoleId:0,
            senderInfo:'',
            senderEmailFrom: null,
            senderPortalUserId: null,
            sendingChannelTypeId: sendingChannelTypeId,
            isRemoved: false,
            recipients: [],
            attachments: [],
            isPriority: false
        };
    }
}